'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

var _effects = require('redux-saga/effects');

var _reactSpectraEditor = require('@complat/react-spectra-editor');

var _action_type = require('../constants/action_type');

var _util_file = require('../utils/util_file');

var _fetcher_file = require('../fetchers/fetcher_file');

var _fetcher_file2 = _interopRequireDefault(_fetcher_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(addOthers);

function addOthers(action) {
  var payload, jcamp, isValidJcampExt, isValidSize, rsp, origData, jcampData;
  return regeneratorRuntime.wrap(function addOthers$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = action.payload;
          jcamp = payload.jcamps[0];
          isValidJcampExt = (0, _util_file.VerifyJcampExt)(jcamp);
          isValidSize = (0, _util_file.VerifySize)(jcamp);

          if (!(isValidJcampExt && isValidSize)) {
            _context.next = 19;
            break;
          }

          _context.next = 7;
          return (0, _effects.call)(_fetcher_file2.default.convertFile, { file: jcamp });

        case 7:
          rsp = _context.sent;

          if (!(rsp && rsp.status)) {
            _context.next = 15;
            break;
          }

          origData = _base2.default.decode(rsp.jcamp);
          jcampData = _reactSpectraEditor.FN.ExtractJcamp(origData);
          _context.next = 13;
          return (0, _effects.put)({
            type: _action_type.JCAMP.ADD_OTHERS_RDC,
            payload: Object.assign({}, { jcamp: jcampData })
          });

        case 13:
          _context.next = 17;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_FAIL,
            payload: payload
          });

        case 17:
          _context.next = 21;
          break;

        case 19:
          _context.next = 21;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_FAIL,
            payload: payload
          });

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked);
}

var jcampSagas = [(0, _effects.takeEvery)(_action_type.JCAMP.ADD_OTHERS_INIT, addOthers)];

exports.default = jcampSagas;